import React from 'react';

import { Tooltip } from 'components/ui/tooltip';

// Store
import { useSelector } from 'store';
import { cn } from 'utils/cn';
import { KIT_FOOTER } from './ModalFooter';

interface Props {
    buttons: React.ReactElement<{ disabled?: boolean }>[];
    extraButtons?: React.ReactElement<{ disabled?: boolean }>[];
    tooltips?: Record<string, string>;
    /** In the new design, the kit dialog's footer (see `ModalFooter`). Classic is unchanged. */
    kit?: boolean;
}

export const ModalFooterSimple = ({ buttons, extraButtons, tooltips, kit }: Props): JSX.Element => {
    const buttonsDisabled = useSelector((state) => state.buttons?.buttonsDisabled);

    const renderElement = (element: React.ReactElement<{ disabled?: boolean }>) => {
        if (!element) return null;
        const cloned = React.cloneElement(element, {
            disabled: buttonsDisabled ? true : element.props.disabled,
        });
        const tooltip = element.key && tooltips?.[element.key];
        if (tooltip) {
            // The span is the hover target: a disabled button fires no pointer events of its own.
            return (
                <Tooltip key={element.key} content={tooltip}>
                    <span className="inline-flex">{cloned}</span>
                </Tooltip>
            );
        }
        return cloned;
    };

    return (
        <div
            className={cn(
                'border-divider bg-grey-0 flex h-20 items-center rounded-b-[12px] border-t px-6 py-2',
                kit && KIT_FOOTER
            )}
        >
            <div className={cn('flex w-full flex-row items-center', extraButtons ? 'justify-between' : 'justify-end')}>
                {extraButtons ? extraButtons.map(renderElement) : null}
                <div className="flex flex-row gap-2">{buttons ? buttons.map(renderElement) : null}</div>
            </div>
        </div>
    );
};
